<script>
  import { BasicDropdown } from "@urbaninstitute/dataviz-components";
  import SliderIcon from "$components/Icons/Slidersalt.svelte";
  import { IconClose } from "@urbaninstitute/dataviz-components/icons";
  import { Accordion } from "bits-ui";
  import FilterGroup from "./FilterGroup.svelte";
  import { RadioGroup, RadioItem } from "$lib/components/Radio/index.js";
  import { useToolData } from "$utils/data.svelte.js";
  import { logClickToGA } from "$utils/analytics.js";

  let { filterType = "chart" } = $props();

  const toolData = useToolData();
  let showMobileControls = $state(false);

  function toggleControls() {
    showMobileControls = !showMobileControls;
  }

  let metricData = toolData.meta.metrics.map((d) => ({ value: d.metric, label: d.label }));

  let frequencies = [
    {
      value: "annual",
      label: "Annual"
    },
    {
      value: "quarterly",
      label: "Quarterly"
    }
  ];

  let mapCategories = toolData
    .getMapCategories()
    .map((cat) => ({ value: cat, label: toolData.formatCategory(cat) }));

  let brandTypes = toolData.meta.brands;

  const CHART_CONTROLS = ["location", "medication", "brand", "frequency"];
  const MAP_CONTROLS = ["time", "medication", "medications", "drug-type", "brand"];

  function getInitialOpenItems() {
    if (filterType === "chart") {
      return CHART_CONTROLS;
    } else {
      return MAP_CONTROLS;
    }
  }

  function getTimeList() {
    let timeList = toolData.timeList
    if (toolData.activeMetric != "numberofprescriptions") {
      timeList = timeList.filter((d) => !d.includes("Q"))
    }
    return timeList.map((timeStr) => ({ label: timeStr, value: timeStr }));
  }
</script>

<div class="control-wrapper-mobile {filterType}">
  {#if filterType === "chart"}
    <div>
      <BasicDropdown
        data={toolData.stateList}
        id="location-select"
        inlineLabel="location-select"
        dropdownWidth={150}
        bind:value={toolData.activeGeo}
      />
    </div>
  {:else}
    <div>
      <BasicDropdown
        data={getTimeList()}
        id="time-select"
        inlineLabel="time-select"
        dropdownWidth={150}
        bind:value={toolData.activeTime}
      />
    </div>
  {/if}
  <div class="filter-button">
    <div class="btn" onclick={toggleControls}>
      <span>Filter data</span>
      <SliderIcon fill="black" size={18} />
    </div>
  </div>
</div>
<div class="control-wrapper-outer" class:show={showMobileControls}>
  <div class="control-wrapper">
    <div class="close-button">
      <div class="btn" onclick={toggleControls}>
        <span>Close filters</span>
        <IconClose fill="black" size={18} />
      </div>
    </div>
    <Accordion.Root type="multiple" value={getInitialOpenItems()}>
      {#if filterType === "chart"}
        <FilterGroup id="location" label="Location">
          <BasicDropdown
            data={toolData.stateList}
            id="location-select"
            inlineLabel="location-select"
            dropdownWidth={220}
            bind:value={toolData.activeGeo}
          />
        </FilterGroup>
      {/if}
      {#if filterType === "map"}
        <FilterGroup id="time" label="Time period">
          <BasicDropdown
            data={getTimeList()}
            id="time-select"
            inlineLabel="time-select"
            bind:value={toolData.activeTime}
          />
        </FilterGroup>
      {/if}
      <FilterGroup id="medication" label="Filled prescriptions">
        <RadioGroup
          bind:value={toolData.activeMetric}
          onValueChange={(value) => logClickToGA(undefined, `click-metric-select-${value}`)}
        >
          {#each metricData as { value, label }}
          {let disabled = $derived(filterType == "chart" ? toolData.activeFrequency == "quarterly" && value != "numberofprescriptions" : toolData.activeTime.includes("Q") && value != "numberofprescriptions")}
            <RadioItem {value} {label} {disabled}></RadioItem>
          {/each}
        </RadioGroup>
      </FilterGroup>
      {#if filterType === "map"}
        <FilterGroup id="medications" label="Medication type">
          <RadioGroup
            bind:value={toolData.activeMapCategory}
            onValueChange={(value) => logClickToGA(undefined, `click-medication-type-${value}`)}
          >
            {#each mapCategories as { value, label }}
              <RadioItem {value} {label}></RadioItem>
            {/each}
          </RadioGroup>
        </FilterGroup>
      {/if}
      <FilterGroup id="brand" label="Brand name versus generic">
        <RadioGroup
          bind:value={toolData.activeMedType}
          onValueChange={(value) => logClickToGA(undefined, `click-brand-type-${value}`)}
        >
          {#each brandTypes as { value, label }}
            <RadioItem {value} {label}></RadioItem>
          {/each}
        </RadioGroup>
      </FilterGroup>
      {#if filterType === "chart"}
        <FilterGroup id="frequency" label="Time period">
          <RadioGroup
            bind:value={toolData.activeFrequency}
            onValueChange={(value) => logClickToGA(undefined, `click-time-period-${value}`)}
          >
            {#each frequencies as { value, label }}
            {let disabled = $derived(toolData.activeMetric !== "numberofprescriptions" && value === "quarterly")}
              <RadioItem {value} {label} {disabled}></RadioItem>
            {/each}
          </RadioGroup>
        </FilterGroup>
      {/if}
    </Accordion.Root>
  </div>
</div>

<style>
  .btn {
    font-family: inherit;
    display: inline-flex;
    gap: var(--spacing-2);
    padding: var(--spacing-2);
    cursor: pointer;
    background: white;
    border: solid 2px var(--color-black);
    justify-content: space-between;
    align-items: center;
    font-weight: var(--font-weight-bold);
  }
  .control-wrapper {
    width: 100%;
  }
  .control-wrapper-outer {
    display: none;
    top: 0;
    bottom: 0;
    left: 0;
    overflow-y: auto;
    background: var(--color-white);
    padding-right: var(--spacing-2);
    width: 100%;
    z-index: 500;
    display: none;
    max-width: 500px;
    scrollbar-color: var(--color-gray) var(--color-white);
    position: absolute;
  }
  .control-wrapper-outer::-webkit-scrollbar-thumb {
    /* Foreground */
    background: var(--color-white);
  }
  .control-wrapper-outer::-webkit-scrollbar-track {
    /* Background */
    background: var(--color-gray-shade-lighter);
  }
  .control-wrapper-outer.show {
    display: block;
  }
  .control-wrapper-mobile {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
/*     
    &.chart{
      flex-direction: column;
      gap: 15px;
    } */
  }
  .control-label {
    font-family: var(--font-family-sans-alt);
    font-weight: var(--font-weight-bold);
    margin-bottom: var(--spacing-1);
  }
  .close-button {
    position: sticky;
    top: 0;
    background: white;
    padding-bottom: var(--spacing-2);
    z-index: 100;
    display: flex;
    justify-content: flex-end;
  }
  .toggle-wrap :global(p.label) {
    margin: 0 !important;
  }
  div :global(select:focus) {
    outline: none !important;
  }
  div :global(select:focus-visible) {
    outline: 2px solid var(--color-blue-shade-darker) !important;
    /* outline-offset: 2px; */
  }

  @media (min-width: 1024px) {
    .close-button {
      display: none;
    }
    .control-wrapper-mobile {
      display: none;
    }
    .control-wrapper-outer {
      display: block;
      padding-right: 0;
      max-width: 270px;
      position: static;
    }
  }
</style>
